<div style="padding: 10px">
  <h3 class="ui primary header" style="margin-bottom: 30px">
    {{ modal.context.title }}
  </h3>
  <app-no-record-found
    *ngIf="applicationsIdea && applicationsIdea.length < 1"
  ></app-no-record-found>
  <div
    class="ui segment"
    style="
      padding-left: 0px;
      padding: 10px;
      margin-bottom: 10px;
      border: 0px;
      margin-top: 20px;
    "
    *ngFor="let application of applicationsIdea"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="start stretch"
      style="align-items: center"
    >
      <div>
        <h1
          style="
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: #505050;
          "
        >
          {{ application?.licenseNumber }}
        </h1>
      </div>
      <div>
        <h1
          style="
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: #505050;
            margin: 0px 25px;
          "
        >
          {{ application?.networkOperatorLicenseType }}
        </h1>
      </div>
      <div>
        <h1
          style="
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            color: #505050;
          "
        >
          {{ application?.dateCreated | date: "d, MMMM y, h:mma" }}
        </h1>
      </div>
    </div>
    <div
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      style="margin-bottom: 0px; margin-top: 20px"
    >
      <div fxFlex="15%" style="align-self: center" class="table-data">
        <h1>Gross Revenue</h1>
        <p style="text-transform: capitalize">
          {{ application?.grossRevenue | amount }}
        </p>
      </div>

      <div fxFlex="15%" style="align-self: center" class="table-data">
        <h1>Interconnect Revenue</h1>
        <p>{{ application?.interconnectCost | amount }}</p>
      </div>

      <div fxFlex="10%" style="align-self: center" class="table-data">
        <h1>Roaming Cost</h1>
        <p>{{ application?.roamingCost | amount }}</p>
      </div>
      <div fxFlex="15%" style="align-self: center" class="table-data">
        <h1>VAS Payable</h1>
        <p>{{ application?.vasPayable | amount }}</p>
      </div>
      <div fxFlex="15%" style="align-self: center" class="table-data">
        <h1>Net Revenue</h1>
        <p>
          {{
            application?.grossRevenue -
              (application?.interconnectCost +
                application?.roamingCost +
                application?.vasPayable) | amount
          }}
        </p>
      </div>
      <div fxFlex="15%" style="align-self: center" class="table-data">
        <h1>2.5% Payable</h1>
        <p>{{ application?.percentPayable | amount }}</p>
      </div>
      <div fxFlex="15%" style="align-self: center" class="table-data">
        <h1>Created By</h1>
        <p>{{ application?.createdBy | createdBy }}</p>
      </div>
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
    style="margin-bottom: 0px; margin-top: 20px"
  >
    <div fxFlex="15%" style="align-self: center" class="table-data"></div>

    <div fxFlex="15%" style="align-self: center" class="table-data"></div>

    <div fxFlex="10%" style="align-self: center" class="table-data"></div>
    <div fxFlex="15%" style="align-self: center" class="table-data"></div>
    <div fxFlex="15%" style="align-self: center" class="table-data"></div>
    <div fxFlex="15%" style="align-self: center" class="table-data">
      <p
        style="
          font-family: 'Roboto';
          font-style: normal;
          font-weight: 600;
          font-size: 18px;
          line-height: 140%;
          color: #505050;
        "
      >
        {{ organizationAolIdea.networkOperatorTotal | amount }}
      </p>
    </div>
    <div fxFlex="15%" style="align-self: center" class="table-data"></div>
  </div>
  <div
    class="actions"
    style="background: transparent; border: none; margin-top: 30px"
  >
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Cancel
    </button>
  </div>
</div>
